import { Outlet, useLocation } from 'react-router-dom';
import { useRef } from 'react';
import Topbar from '@/components/admin/Topbar';
import ClientMobileTopbar from '@/components/client/mobile/ClientMobileTopbar';
import ClientMobileBottomNav from '@/components/client/mobile/ClientMobileBottomNav';
import SidebarClient from './SidebarClient';
import SidebarCommunity from './SidebarCommunity';
import SEO from '@/components/common/SEO';
import { ScrollContainerProvider } from '@/contexts/ScrollContainerContext';
import { useSidebar } from '@/contexts/SidebarContext';
import { useAuth } from '@/contexts/AuthContext';
import {
  clientPaths,
  isCommunityDetailPath,
  isPath,
  isPublicProfilePath,
} from '@/utils/clientPaths';

const ClientLayout = () => {
  const { isCollapsed } = useSidebar();
  const { user } = useAuth();
  const mobileMainRef = useRef<HTMLElement>(null);
  const location = useLocation();

  const isCommunityUser =
    user?.role === 'community' ||
    (typeof localStorage !== 'undefined' && localStorage.getItem('sporto_role') === 'community');

  const isNoTopbar =
    isCommunityDetailPath(location.pathname) ||
    isPublicProfilePath(location.pathname) ||
    isPath(location.pathname, clientPaths.profile.settings) ||
    location.pathname.includes('/badminton/tambah-game') ||
    /\/badminton\/game\/[^/]+\/skor$/.test(location.pathname) ||
    /\/padel\/game\/[^/]+\/skor$/.test(location.pathname);

  return (
    <>
      <SEO
        title={isCommunityUser ? 'Sporto Community' : 'Sporto Client'}
        description={isCommunityUser ? 'Dashboard community Sporto' : 'Dashboard pengguna Sporto'}
        url={isCommunityUser ? '/host' : '/'}
        noIndex={true}
      />
      {/* Desktop and Tablet Layout */}
      <div className="hidden md:flex min-h-screen bg-gray-50 overflow-x-hidden">
        <aside
          className={`shrink-0 bg-white border-r transition-[width] duration-300 ease-in-out relative z-20 ${
            isCollapsed ? 'w-20' : 'w-64'
          }`}
        >
          {isCommunityUser ? <SidebarCommunity /> : <SidebarClient />}
        </aside>
        <div className="flex-1 min-w-0 flex flex-col overflow-x-hidden">
          <Topbar page={isCommunityUser ? 'community' : 'client'} />
          <main className="p-6 flex-1 overflow-auto">
            <Outlet />
          </main>
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="md:hidden min-h-screen flex flex-col bg-[#F8FAFC]">
        <ClientMobileTopbar />

        <ScrollContainerProvider value={mobileMainRef}>
          <main
            ref={mobileMainRef}
            className={`flex-1 overflow-auto pb-safe-offset-20 ${
              isNoTopbar ? 'pt-safe' : 'pt-safe-offset-14'
            }`}
          >
            <Outlet />
          </main>
        </ScrollContainerProvider>

        <ClientMobileBottomNav />
      </div>
    </>
  );
};

export default ClientLayout;
